// import Vue from 'vue'

export default {
  SET_AUDITS_GRID (state, payload) {
    state.auditsGrid = payload
  }
}
